/** Which measuring system the plan is displayed in. Defaults to feet and inches. */
import create from 'zustand'

export type UnitSystem = 'imperial' | 'metric';

export interface UnitStore {
    unit: UnitSystem,
    setUnit: (unit: UnitSystem) => void,
    toggleUnit: () => void
}

export const useUnitStore = create<UnitStore>((set, get) => ({
    unit: 'imperial',
    setUnit: (unit: UnitSystem) => set(() => ({ unit })),
    toggleUnit: () => set(() => ({ unit: get().unit === 'imperial' ? 'metric' : 'imperial' })),
}))
